<template lang="html">
  <div>
    <input
      type="file"
      style="display: none"
      ref="image"
      accept="image/*"
      @change="onFilePicked"
    >

    <!-- Card  -->
    <v-card>
      <v-img
        v-if="fileBlob"
        :src="imageToShow"
        aspect-ratio="1"
      ></v-img>

      <v-layout v-else align-center justify-center column fill-height style="height:250px;">
        <img src="@/assets/images/album/albumArtPlaceHolder.svg" style="height:100px;">
        <v-btn flat color="primary" @click='pickFile'>Selecionar Imagem</v-btn>
      </v-layout>

      <v-card-actions>
        <!-- <v-btn flat color="primary" @click='pickFile'>Selecionar</v-btn> -->
        <v-btn flat color="primary" v-if="fileBlob" @click="removeCover()">Remover</v-btn>
      </v-card-actions>

    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String
    }
  },
  computed: {
    fileBlob: {
      get: function() {
        return this.value
      },
      set: function(val) {
        this.$emit('input', val)
      }
    },
    imageToShow: function () {
      if(this.fileBlob){
        return this.fileBlob
      } else {
        return require('@/assets/images/album/albumArtPlaceHolder.svg')
      }
    }
  },
  methods:{
    pickFile() {
      this.$refs.image.click()
    },
    onFilePicked(e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        // this.imageName = files[0].name
        if (files[0].name.lastIndexOf('.') <= 0) {
          return
        }
        // const fr = new FileReader()

        var reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = (e) => {
            console.log('DataURL:', e.target.result);
            this.fileBlob = e.target.result
        };

      } else {
        this.fileBlob = null
        // this.imageName = ''
        // this.imageFile = ''
        // this.imageUrl = ''
      }
    },
    removeCover: function () {
      this.fileBlob = null
    },
  }
}
</script>

<style lang="css" scoped>
</style>
